import RecoverFreespins from "slotworks/state-machine/standard/states/recover-freespins";
import { ChangeMatrixFreespinsCommand } from "commands/change-matrix-freespins-command";
import Layers from "slotworks/graphics/layers/layers";
import { LLCustomLayers } from "../../../lib/luck-and-luxury/src/names";

export class CGRecoverFreespins extends RecoverFreespins {
    public onEnter() {
        ChangeMatrixFreespinsCommand(true);
        super.onEnter();

        if (Layers.Custom.get(LLCustomLayers.LOGOS).hasScene("freespins")) {
            Layers.Custom.get(LLCustomLayers.LOGOS).setScene("freespins").execute();
        }
    }
}
